import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";

//ANT DESIGN IMPORTS
import {
    Input,
    Row,
    Card,
    Form,
    DatePicker,
    Col,
    Divider,
    Spin
} from "antd";

//PROJECT IMPORTS
import Close from "./Close";
import ApproveGroupSavings from "./Approve";
import UndoApproval from "./UndoApproval";
import AddCharge from "./AddCharge";
import Reject from "./Reject";
import WithdrawnByApplicant from "./WithdrawnByClient";
import AssignOfficer from "./AssignOfficer";
import UnassignOfficer from "./UnassignOfficer";
import ModifyApplication from "./ModifyApplication";
import Activate from "./Activate";


const GroupsSavingsMainActionPage = (props) => {
    const { userData } = props;
    const { state } = useLocation();

    useEffect(() => {
        // console.log(state);
    }, []);

    const renderActions = () => {
        switch (state?.actionLabel?.toLowerCase()) {
            case "modify application":
                return <ModifyApplication userData={userData} />;
            case "add charge":
                return <AddCharge userData={userData} />;
            case "withdrawn by client":
                return <WithdrawnByApplicant userData={userData} />;
            case "reject":
                return <Reject userData={userData} />;
            case "approve":
                return <ApproveGroupSavings userData={userData} />;
            case "undo approval":
                return <UndoApproval userData={userData} />;
            case "assign officer":
                return <AssignOfficer userData={userData} pageTitleParam={state?.actionLabel} />;
            case "unassign officer":
                return <UnassignOfficer userData={userData} pageTitleParam={state?.actionLabel} />;
            case "activate":
                return <Activate userData={userData} pageTitleParam={state?.actionLabel} />;

            default:
                return <>No {state.actionLabel} Component found contact dev</>;
        }
    };
    return <>{renderActions()}</>;
};

const mapStateToProps = (state) => ({
    userData: state.AuthenticationData.userData,
});
export default connect(mapStateToProps, null)(GroupsSavingsMainActionPage);
